export const APPLY_PROJECTS = 'APPLY_PROJECTS'
export const PARTIALLY_APPLY_PROJECTS = 'PARTIALLY_APPLY_PROJECTS'
export const EXPAND_PROJECT = 'EXPAND_PROJECT'
export const CREATE_PROJECT = 'CREATE_PROJECT'
export const ADD_PROJECT = 'ADD_PROJECT'
export const CHANGE_PROJECT = 'CHANGE_PROJECT'
export const UPDATE_PROJECT = 'UPDATE_PROJECT'
export const DESTROY_PROJECT = 'DESTROY_PROJECT'
export const REMOVE_PROJECT = 'REMOVE_PROJECT'
export const MERGE_PERMALINK_PROJECT = 'MERGE_PERMALINK_PROJECT'
export const APPLY_LEGACY_PROJECTS = 'APPLY_LEGACY_PROJECTS'
export const MIGRATE_LEGACY_PROJECT = 'MIGRATE_LEGACY_PROJECT'
export const CHANGE_PROJECT_FROM_STARTUP = 'CHANGE_PROJECT_FROM_STARTUP'
export const CREATE_PROJECT_FROM_STARTUP = 'CREATE_PROJECT_FROM_STARTUP'
export const MARK_LEGACY_PROJECT_HIDDEN = 'MARK_LEGACY_PROJECT_HIDDEN'
export const REMOVE_LEGACY_PROJECT = 'REMOVE_LEGACY_PROJECT'
export const DUPLICATE_PROJECT = 'DUPLICATE_PROJECT'
export const CLEAR_PROJECTS = 'CLEAR_PROJECTS'
export const SELECT_PROJECT = 'SELECT_PROJECT'
export const CREATE_MOBILE_PROJECT = 'CREATE_MOBILE_PROJECT'



// WEBPACK FOOTER //
// ./src/actions/projectActionTypes.js